import { render, staticRenderFns } from "./UnidataEditorCorrelator.vue?vue&type=template&id=b091a648&"
import script from "./UnidataEditorCorrelator.vue?vue&type=script&lang=js&"
export * from "./UnidataEditorCorrelator.vue?vue&type=script&lang=js&"
import style0 from "./UnidataEditorCorrelator.vue?vue&type=style&index=0&id=b091a648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports